import cogoToast from 'cogo-toast'

let lastUnauthorizedPromptAt = 0
let unauthorizedRedirectTimer = null

const protectedApiPrefixes = [
  '/product/address/',
  '/product/order/',
  '/product/cart/',
  '/common/order/',
  '/product/prd',
]

const getRequestPathname = (error) => {
  const requestUrl = error.config?.url || ''
  const baseURL = error.config?.baseURL || window.location.origin

  try {
    return new URL(requestUrl, baseURL).pathname.replace(/^\/api/, '')
  } catch (e) {
    return requestUrl
  }
}

export const clearAuthStorage = () => {
  localStorage.removeItem('user_info')
  localStorage.removeItem('auth_token')
}

export const notifyUnauthorized = (message = 'Login expired, please login again') => {
  clearAuthStorage()

  const now = Date.now()
  if (now - lastUnauthorizedPromptAt > 1500) {
    cogoToast.error(message, { position: 'top-center' })
    lastUnauthorizedPromptAt = now
  }

  if (unauthorizedRedirectTimer) return

  unauthorizedRedirectTimer = setTimeout(() => {
    window.location.href = process.env.PUBLIC_URL + '/login'
  }, 1000)
}

export const isUnauthorizedResponse = (error) => {
  const status = error.response?.status || error.status
  const data = error.response?.data || {}
  const requestPathname = getRequestPathname(error)
  const hasTokenHeader = Boolean(error.config?.headers?.token)
  const isProtectedApi = protectedApiPrefixes.some((prefix) => requestPathname.startsWith(prefix))
  const isMaskedUnauthorized = error.code === 'ERR_NETWORK' && !error.response && hasTokenHeader && isProtectedApi

  return status === 401 || data.code === 401 || data.message === 'Invalid or missing token.' || isMaskedUnauthorized
}
